/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { PolygonSelectModel } from './polygon-select.model';

export class UpdateSelectionMode {
    static readonly type = '[PolygonSelect] Set selection mode';

    constructor(public payload: PolygonSelectModel) {}
}
